import React, {useState, useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCategoriesForAdmin, deleteCategory } from '../../actions/AdminCategoryActions';
import addIcon from '../adminIcons/add.svg'
import Edit_primary from '../adminIcons/Edit_primary.svg'
import CrossIcon from '../adminIcons/del.svg'
import AdminModal from '../../app-main-content/AdminModal'
import AddCategory from './AddCategory';
import { useNavigate } from 'react-router-dom'

const AdminCategories = () => {

    const dispatch = useDispatch()

    const [addActive, setAddActive] = useState()

    const navigate = useNavigate()

    useEffect(()=>{
        dispatch(getCategoriesForAdmin())
    },[])

    const { adminCategories, loadingAdminCategories } = useSelector(state=>state.adminCategories)


    const deleteHandler = (e, id) => {
        e.stopPropagation()
        var answer = window.confirm("Are you sure you want to delete this category?");
        if(answer){
            dispatch(deleteCategory(id))
        }
    }


    return (
        <div className = 'col-9 bg-success p-4 my-5 me-5 rounded col-9' style={{marginLeft:"16vw", minHeight:"100vh"}}>
            <div className = 'pb-4 d-flex justify-content-between align-items-center pe-5'>
                <div className = "fw-bold fs-7 text-info" 
                    role='button' 
                >CATEGORIES</div>
                <div className = 'bg-secondary rounded-pill px-3 d-flex align-items-center'
                    style={{height:"40px"}}
                    role='button'
                    onClick = {()=>{setAddActive(true)}}
                    >
                    <img src = {addIcon}/>
                    <div className='text-white ps-1 text-nowrap'
                    >Add Category</div>
                </div>
            </div>

                <div className = "my-3 bg-info w-100" style={{height:"2px"}}></div>

                <div className = 'p-3 d-flex'>        
                    <div className = 'text-info col-2 text-center'>Icon</div>            
                    <div className = 'text-info col-5 text-center'>Title</div>
                    <div className = 'text-info col-3 text-center'>Status</div>
                </div>
                {
                    loadingAdminCategories ?
                    <div className = 'text-center text-info'>Loading...</div>
                    :
                    adminCategories && adminCategories.length && adminCategories.map((category, index) => {
                        return (
                               <div    
                                   id={category.id}
                                   className='p-3 border border-secondary rounded d-flex my-2'
                                   key = {index}
                                   onClick={()=>navigate(`/editCategory/${category.id}`)}
                                   role='button'
                                   >
                                    <div className='col-2 d-flex justify-content-center align-items-center'>
                                        <img  src = {`https://img.cugate.com/?o=CUTV_TAGICON&i=${category.id}&s=mega`} width='20' alt = 'bb'/>
                                    </div>
                                    <div className = 'text-info col-5 text-center'>{category.title}</div>
                                    <div className = 'col-3 d-flex justify-content-center align-items-center'>
                                       {
                                           category.status? 
                                           <div className = 'text-info'>ON</div> : <div className = 'text-info'>OFF</div>
                                       }
                                   </div>    
                                   <div className = 'd-flex col-2 justify-content-center'>
                                       <img 
                                           className = 'p-1' 
                                           style={{width:"22px"}}
                                           src = {Edit_primary}
                                           role = 'button'
                                           onClick={()=>navigate(`/editCategory/${category.id}`)}
                                           alt = ""></img>
                                       <img 
                                           className = 'p-1' 
                                           role = 'button'
                                           style={{width:"36px"}}  
                                           src = {CrossIcon}
                                           onClick = {(e)=>deleteHandler(e, category.id)}
                                           alt = ""></img>
                                   </div>
                                   
                               </div>
                        )
                    })
                }
                <AdminModal 
                    trigger = {addActive}
                    setTrigger = {setAddActive}
                    content = {
                        <AddCategory
                            setIsActive = {setAddActive}
                        /> 
                    }
                /> 
            </div>
    );
};

export default AdminCategories;